// ///////////////////////////////////////////////////////////
// tbLoader: The engine part dealing with loading
//
// Copyright 2013-2015 CoolGames
// Last Changed: 9-6-2015
// ///////////////////////////////////////////////////////////
import { LoadManager } from "../code/asset_loading/LoadManager";
import { tbGame } from "./tbGame";
// The constructor for the loader object
var TBLoader = function () {
    "use strict";
    this._location = ""; // Location of the data files
    this._loading = []; // Whether this moment is being loaded or has been loaded before
    this._total = []; // Total number of items to be loaded for each moment
    this._loaded = []; // Number of items that are loaded for each moment
    this._failed = []; // Number of items that failed for each moment
    this._items = []; // The items to be loaded for each moment
};
// Set the data location
TBLoader.prototype.setDataLocation = function (location) {
    "use strict";
    this._location = location;
    if (this._location !== "" && this._location[this._location.length - 1] !== "/") {
        this._location += "/";
    }
};
// Get the data location
TBLoader.prototype.getDataLocation = function () {
    "use strict";
    return this._location;
};
// Initialize a moment
TBLoader.prototype.addMoment = function (moment) {
    "use strict";
    if (this._items[moment]) {
        return;
    } // It already exists
    this._total[moment] = 0;
    this._loaded[moment] = 0;
    this._failed[moment] = 0;
    this._items[moment] = [];
    this._loading[moment] = false;
};
TBLoader.prototype.exist = function (moment) {
    "use strict";
    if (this._items[moment] && this._items[moment].length > 0) {
        return true;
    }
    return false;
};
// Return total number of items to load for the moment
TBLoader.prototype.total = function (moment) {
    "use strict";
    if (!this._items[moment]) {
        return 0;
    }
    return this._total[moment];
};
// Return number of loaded items for the moment
TBLoader.prototype.loaded = function (moment) {
    "use strict";
    if (!this._items[moment]) {
        return 0;
    }
    return this._loaded[moment];
};
// Return number of failed items for the moment
TBLoader.prototype.failed = function (moment) {
    "use strict";
    if (!this._items[moment]) {
        return 0;
    }
    return this._failed[moment];
};
// Return whether all items are loaded for the moment
TBLoader.prototype.complete = function (moment) {
    "use strict";
    if (!this._items[moment]) {
        return true;
    }
    return (this._loaded[moment] + this._failed[moment] === this._total[moment]);
};
// Return percentage of items that are loaded for the moment
TBLoader.prototype.percentage = function (moment) {
    "use strict";
    if (!this._items[moment] || this._total[moment] === 0) {
        return 100;
    }
    return (100 * (this._loaded[moment] + this._failed[moment]) / this._total[moment]);
};
// Report that a resource is correctly loaded
TBLoader.prototype.loadComplete = function (moment) {
    "use strict";
    this._loaded[moment] += 1;
    if (this.complete(moment)) {
        tbGame.addSpecial("Load Complete", { moment: moment });
    }
};
// Report that a resource failed to load
TBLoader.prototype.loadFailed = function (moment) {
    "use strict";
    this._failed[moment] += 1;
    tbGame.addSpecial("Load Failed", { moment: moment });
};
// Add a resource to be loaded, number indicated the number of subresources
TBLoader.prototype.addResource = function (resource, moment, number) {
    "use strict";
    if (!this._items[moment]) {
        this.addMoment(moment);
    }
    this._items[moment].push(resource);
    this._total[moment] += number;
};
// check if textures are loaded for spine
TBLoader.prototype.checkSpineLoad = function () {
    if (!this._items["spine"]) {
        return;
    }
    for (var i = 0; i < this._items["spine"].length; i += 1) {
        if (this._items["spine"][i].checkTexture()) {
            this._items["spine"][i].startLoading();
        }
    }
};
TBLoader.prototype.startLoading = function (moment) {
    // This is a Tingly engine defined default load moment that loads the default engine audio, which we do not make use of in Battleship.
    // So we skip it for optimization.
    if (moment === "frameworkAudio") {
        this._items[moment] = null;
        return;
    }
    LoadManager.loadAssetsInMoment(moment).then(function () {
        console.log("Engine Moment Loaded", moment);
    }, function (reason) {
        console.log("Engine Asset(s) Load Error", reason);
    });
};
TBLoader.prototype.getResourcesForMoment = function (moment) {
    return this._items[moment];
};
TBLoader.prototype.createMoment = function (moment, assets) {
    return this._items[moment] = assets;
};
// Create the loader
export var tbLoader = new TBLoader();
